import { Link } from "react-router-dom";

const IMGS = [
  "https://images.unsplash.com/photo-1634241796701-24569ef1c554?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxlZGl0b3JpYWwlMjBsaW5nZXJpZSUyMGZhc2hpb258ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1642945680515-faada4c0ca7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxsYWNlJTIwYnJhJTIwbGluZ2VyaWV8ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1750064139819-da3bf362e7b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxzaWxrJTIwcm9iZSUyMHNsZWVwd2VhcnxlbnwwfHx8fDE3ODMwODExNTZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1766056278976-87f269e3b69c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxzaWxrJTIwcm9iZSUyMHNsZWVwd2VhcnxlbnwwfHx8fDE3ODMwODExNTZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1568663521381-33b7c467fda0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxsYWNlJTIwYnJhJTIwbGluZ2VyaWV8ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1610241519159-8a62634bac9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxsYWNlJTIwYnJhJTIwbGluZ2VyaWV8ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85",
];

export default function Lookbook() {
  return (
    <div data-testid="lookbook-page">
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-16 pb-8">
        <div className="overline text-[#4A1525] mb-4">Volume 01</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tighter mb-6 max-w-4xl">A private<br/><em className="text-[#4A1525] font-light">correspondence.</em></h1>
        <p className="text-[#5C5C5C] max-w-xl text-lg leading-relaxed">Photographed in a quiet Parisian apartment. Light filtering through voile. Whispers of silk on skin.</p>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-12 gap-4 lg:gap-8">
        <img src={IMGS[0]} alt="LB1" className="col-span-12 md:col-span-8 aspect-[4/5] object-cover" />
        <div className="col-span-12 md:col-span-4 flex flex-col justify-end">
          <div className="overline text-[#4A1525] mb-4">Chapter I</div>
          <p className="font-serif text-2xl italic leading-relaxed">"The way a woman wears her lace is her signature."</p>
        </div>

        <img src={IMGS[1]} alt="LB2" className="col-span-6 md:col-span-4 aspect-[3/4] object-cover" />
        <img src={IMGS[2]} alt="LB3" className="col-span-6 md:col-span-4 aspect-[3/4] object-cover" />
        <img src={IMGS[3]} alt="LB4" className="col-span-12 md:col-span-4 aspect-[3/4] object-cover" />

        <div className="col-span-12 md:col-span-5 flex flex-col justify-center py-12">
          <div className="overline text-[#4A1525] mb-4">Chapter II</div>
          <h2 className="font-serif text-4xl md:text-5xl leading-tight mb-6">Dressing<br/>for oneself.</h2>
          <p className="text-[#5C5C5C] leading-relaxed">The pieces you wear beneath everything else. They set the tone for the day.</p>
        </div>
        <img src={IMGS[4]} alt="LB5" className="col-span-12 md:col-span-7 aspect-[4/3] object-cover" />

        <img src={IMGS[5]} alt="LB6" className="col-span-12 aspect-[16/7] object-cover" />
      </section>

      <section className="text-center py-24">
        <Link to="/shop" className="bg-[#4A1525] text-[#FAF8F5] px-10 py-5 overline hover:bg-[#360F1B] transition-colors" data-testid="lb-shop-cta">Shop the Volume</Link>
      </section>
    </div>
  );
}
